export default "__VITE_ASSET__COLdvnvC__"